import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { UsageAnalytics } from '~/modules/analytics/usage';

import { getSchemaDefaults } from '@vestigas/utils';
import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams, zodAnalyticsSearchParamsSchema } from './-routeParams';

const title = i18n.t(($) => $.usage.pageTitle, { ns: 'analytics' });

export const Route = createFileRoute('/(main)/analytics/usage/')({
  beforeLoad: createProtectedRoute({
    routePath: '/analytics/usage',
    ...routeParams,
  }),
  component: UsageAnalytics,
  head: () => getRouteHead(title),
  search: {
    middlewares: [
      stripSearchParams(getSchemaDefaults(zodAnalyticsSearchParamsSchema)),
    ],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodAnalyticsSearchParamsSchema,
});

export const ANALYTICS_USAGE = buildRouteExport({ Route, ...routeParams });
